import React from 'react';
import { useHistory } from 'react-router-dom';

import Button from '../Button';
import Title from '../Title';
import { Pluss, Check } from '../../static';
import { s3LoadUrl } from '../../helper/s3LoadUrl';

import './styles.scss';

const Card = ({ virus }) => {
	const history = useHistory();
	const handleRedirectVirus = () => {
		history.push(`/virus/${id}/`);
	};

	const handleRedirectVirusForm = (event) => {
		event.stopPropagation();
		history.push(`/virus/${id}/add-virus`);
	};
	
	const id = virus.id ? virus.id : virus.objectID;

	let bgUrl ='';

	if(virus.backgroundImage) {
		bgUrl = s3LoadUrl(virus.backgroundImage);
	};

	return (
		<div 
			onClick={handleRedirectVirus}
			className="card"
		>
			{virus && (
				<>	
					<div className="card__bg">
						<img src={bgUrl} alt="virus-color"/>
					</div>
					<Title text={virus.name} isCard isWhite/> 
					<div className="card__controls">
						<div className="card__btn card__btn--left">
							<Button 
								text='Add Patient' 
								type='button' 
								leftIcon={<Pluss />} 
								isLight
								onClick={handleRedirectVirusForm}
							/>
						</div>
						<div className="card__btn card__btn--right">
							<Button 
								text='Details' 
								type='button' 
								leftIcon={<Check />} 
								isLight
								onClick={handleRedirectVirus}
							/>
						</div>
					</div>
				</>
			)}
		</div>
	);
};

export default Card;
